<template>
  <div :class="{ 'input-block': true, 'input-block-margin': block, 'custom-input-tamanho': input }">
    <div>
      <label :aria-label="label" v-if="label" :class="{ 'validator-error': v.$invalid && v.$dirty, lb: true }">{{ label }}<span v-if="requiredLabel()">*</span></label>
      <div :class="{ 'radio-block': true }">
        <slot></slot>
      </div>
    </div>
    <transition name="helper-trans" enter-active-class="animated fadeInDown">
      <div v-if="this.v.$dirty" class="validator-error helper-text">{{ getError() }}</div>
    </transition>
  </div>
</template>

<script>
import { getMessages } from '@/validations';

export default {
  name: 'Validator',
  props: {
    label: { type: String, default: '' },
    flex: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    input: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      default() {
        return {
          $invalid: false,
          $dirty: false,
          $params: [],
        };
      },
    },
  },
  methods: {
    getError() {
      if (!this.v.$dirty) { return ''; }

      for (const p in this.v.$params) {
        if (!this.v[p]) {
          return getMessages(p, this.v.$params[p]);
        }
      }
    },
    requiredLabel() {
      return typeof this.v.$params.required !== 'undefined';
    },
  },
};
</script>

<style lang="scss">
.input-block{
  width: 60%;
  position: relative;
  margin-bottom: 13px;

  .radio-block {
    display: flex;
    flex-wrap: wrap;
  }

  .lb{
    display: block;
    font-weight: 600!important;
  }
  .helper-text{
    font-size: 11px;
    margin-top: 1px;
    margin-left: 12px;
  }
  .validator-error{
    color: #b00020;

  }
}

.input-block-margin{
  border: 1px solid #757575;
  padding: 13px 9px 5px 9px;
  border-radius: 4px;
  margin-top: 6px;

  .lb{
    transform: translateX(-4%) translateY(-113%) scale(.90);
    background-color: white;
    position: absolute;
    padding: 0px 4px;
  }
}

@media only screen and (max-width: 700px){
  .input-block{
    width: 100%;
  }
}
</style>
